export default __webpack_public_path__ + "static/media/test1.0dd20c5b.png";